// extracted by mini-css-extract-plugin
export default {"container":"DetailLembur_container__YcclL","form_container":"DetailLembur_form_container__TSJGa"};